import { useMutation, UseMutationResult } from 'react-query';
import { AxiosResponse } from 'axios';
import { UseMutationOptions } from 'react-query/types/react/types';
import { LoginConfigApi, SetAnonymousShoppersLoginDisabledDto } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

type UseToggleAnonymousLogin = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>,
    ErrorResponse,
    SetAnonymousShoppersLoginDisabledDto>,
    'mutationFn'>,
) => UseMutationResult<AxiosResponse<void>,
  ErrorResponse,
  SetAnonymousShoppersLoginDisabledDto>;

export const useToggleAnonymousLogin: UseToggleAnonymousLogin = (
  options,
) => {
  const loginConfigApi = new LoginConfigApi(getApiConfiguration());
  return useMutation(
    (setAnonymousShoppersLoginDisabledDto: SetAnonymousShoppersLoginDisabledDto) =>
      loginConfigApi.setAnonymousShoppersLoginDisabled(setAnonymousShoppersLoginDisabledDto),
    options,
  );
};
